import { render, staticRenderFns } from "./AvenantTypePropertyEditor.vue?vue&type=template&id=f2c1df56"
import script from "./AvenantTypePropertyEditor.vue?vue&type=script&lang=ts"
export * from "./AvenantTypePropertyEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports